document.addEventListener("DOMContentLoaded", function () {
  // ====================== 岗位名称获取与回填（支持刷新持久化） ======================
  (function () {
    var params = new URLSearchParams(window.location.search);
    var rawJobTitle = params.get("job_title");

    // 1. 逻辑判断：如果 URL 里有参数，就存入缓存；如果没有，尝试从缓存读取
    if (rawJobTitle) {
      sessionStorage.setItem('current_applying_job', rawJobTitle);
    } else {
      rawJobTitle = sessionStorage.getItem('current_applying_job');
    }

    // 如果两者都没有，才退出
    if (!rawJobTitle) return;

    function normalizeJobTitle(value) {
      if (typeof value !== "string") return "";
      var result = value
        .replace(/-/g, " ")
        .trim()
        .replace(/\s{2,}/g, " ");
      return result.length > 200 ? result.slice(0, 200) : result;
    }

    var jobTitle = normalizeJobTitle(rawJobTitle);
    var titleElement = document.getElementById("job-application-title");
    var inputElement = document.getElementById("job-application-input");

    if (titleElement && jobTitle) {
      titleElement.textContent = jobTitle;

      // 如果有标题，就把“正在申请”也显示出来
      var subtitle = document.getElementById("job-subtitle");
      if(subtitle) subtitle.style.display = "block";
    }
    
    // 2. 核心修复：即使是提交后的页面，也要把这个值填回隐藏域
    // 这样万一用户提交失败需要重新填表，岗位信息依然会被包含在下一次提交中
    if (inputElement && jobTitle) {
      inputElement.value = jobTitle;
    }
  })();

  // ====================== 模块3 教育经历 - 添加/删除 ======================
  // const addBtn = document.getElementById("addEducation");
  // const deleteBtn = document.getElementById("deleteEducation");
  // const container = document.querySelector(".education-container");
  
  // // 【重点修复】直接获取模板内部的那个 .education-item 节点，而不是外层的包装盒
  // const templateNode = document.querySelector(".education-item-template .education-item");
  
  // const MAX_GROUPS = 3; // 最多3组
  // const MIN_GROUPS = 1; // 最少1组

  // 【重点修复】写一个辅助函数：只获取容器直接子级中实际显示的 .education-item（排除隐藏的模板）
  // function getActualItems() {
  //   if (!container) return [];
  //   return Array.from(container.children).filter(child => child.classList.contains("education-item"));
  // }

  // 初始化按钮状态
  // updateBtnStatus();

  // 添加教育经历
  // addBtn.addEventListener("click", function () {
  //   const activeItems = getActualItems();
  //   console.log("准备添加，当前实际教育组数：", activeItems.length);
    
  //   if (activeItems.length >= MAX_GROUPS) return;

  //   // 1. 克隆模板
  //   const clone = templateNode.cloneNode(true);
    
  //   // 2. 【核心修复】给克隆出来的必填项加上 required
  //   // 排除掉非必填的“在校经历”(textarea)
  //   const fieldsToRequire = clone.querySelectorAll("input:not([name*='在校经历']), select");
  //   fieldsToRequire.forEach(field => {
  //     field.required = true; 
  //   });

  //   // 3. 【清空逻辑】确保克隆出来的表单值是空的
  //   const allInputs = clone.querySelectorAll("input, select, textarea");
  //   allInputs.forEach(input => {
  //     if (input.tagName === 'SELECT') {
  //       input.selectedIndex = 0; 
  //     } else {
  //       input.value = ""; 
  //     }
  //   });

  //   // 4. 挂载到容器并更新状态
  //   container.appendChild(clone);
  //   updateBtnStatus();
  // });

  // 删除最新一组
  // deleteBtn.addEventListener("click", function () {
  //   const activeItems = getActualItems();
  //   console.log("准备删除，当前实际组数：", activeItems.length);
    
  //   // 保护机制：如果只剩最少组数，直接 return
  //   if (activeItems.length <= MIN_GROUPS) return;

  //   // 删除数组中的最后一个实际项
  //   const lastItem = activeItems[activeItems.length - 1];
  //   lastItem.remove();

  //   updateBtnStatus();
  // });

  // 更新按钮禁用状态
  // function updateBtnStatus() {
  //   const currentCount = getActualItems().length;
  //   addBtn.disabled = currentCount >= MAX_GROUPS;
  //   deleteBtn.disabled = currentCount <= MIN_GROUPS;
  // }

  // ====================== 模块4 工作经验 - 逻辑处理 ======================
  // const addExpBtn = document.getElementById("addExperience");
  // const deleteExpBtn = document.getElementById("deleteExperience");
  // const expContainer = document.querySelector(".experience-container");
  // const expTemplateNode = document.querySelector(".experience-item-template .experience-item");
  // const noExpCheckbox = document.getElementById("NoExperienceCheckbox");
  // const expFieldsArea = document.querySelector(".experience-fields-area");

  // function getActualExpItems() {
  //   return Array.from(expContainer.children).filter(child => child.classList.contains("experience-item"));
  // }

  // 需求5：勾选“没有工作经验”时的逻辑
  // noExpCheckbox.addEventListener("change", function() {
  //   if(this.checked) {
  //     expFieldsArea.style.opacity = "0.5";
  //     expFieldsArea.style.pointerEvents = "none";
  //     // 取消必填项要求
  //     expFieldsArea.querySelectorAll("[required]").forEach(el => el.required = false);
  //   } else {
  //     expFieldsArea.style.opacity = "1";
  //     expFieldsArea.style.pointerEvents = "auto";
  //     // 恢复第一组的必填项
  //     const firstItem = getActualExpItems()[0];
  //     firstItem.querySelectorAll("input:not([type='date']), select").forEach(el => el.required = true);
  //     // 日期区间也恢复必填
  //     firstItem.querySelectorAll("input[type='date']").forEach(el => el.required = true);
  //   }
  // });

  // // 添加逻辑
  // addExpBtn.addEventListener("click", function () {
  //   const items = getActualExpItems();
  //   if (items.length >= 3) return;

  //   // 1. 克隆模板
  //   const clone = expTemplateNode.cloneNode(true);
    
  //   // 2. 【核心修复】加上 required (排除掉非必填的“工作描述”)
  //   const fieldsToRequire = clone.querySelectorAll("input:not([name*='描述']), select");
  //   fieldsToRequire.forEach(field => {
  //     field.required = true; 
  //   });

  //   // 3. 【清空逻辑】
  //   const allInputs = clone.querySelectorAll("input, select, textarea");
  //   allInputs.forEach(input => {
  //     if (input.tagName === 'SELECT') {
  //       input.selectedIndex = 0;
  //     } else {
  //       input.value = "";
  //     }
  //   });

  //   // 4. 挂载
  //   expContainer.appendChild(clone);
  //   updateExpBtnStatus();
  // });

  // deleteExpBtn.addEventListener("click", function () {
  //   const items = getActualExpItems();
  //   if (items.length <= 1) return;
  //   items[items.length - 1].remove();
  //   updateExpBtnStatus();
  // });

  // function updateExpBtnStatus() {
  //   const count = getActualExpItems().length;
  //   addExpBtn.disabled = count >= 3;
  //   deleteExpBtn.disabled = count <= 1;
  // }

  // ====================== 核心：提交时拼接分类数据（发送到邮箱） ======================
  const form = document.getElementById('RecruitmentForm');
  const formattedBodyInput = document.getElementById('formatted-body');
  const submitBtn = document.getElementById('SubmitResumeBtn');

  form.addEventListener('submit', function (e) {
    // --- 1. 基础信息拼接 ---
    // 注意：使用 trim() 清除模板字面量自带的换行空格，让邮件更整齐
    const formattedData = `
--- 基本信息 ---
姓名：${document.getElementById('RecruitmentForm-name').value || '未填写'}
手机号：${document.getElementById('RecruitmentForm-phone').value || '未填写'}
邮箱：${document.getElementById('RecruitmentForm-email').value || '未填写'}
性别：${document.getElementById('RecruitmentForm-gender').value || '未选择'}
出生年月：${document.getElementById('RecruitmentForm-birth').value || '未选择'}
籍贯：${document.getElementById('RecruitmentForm-origin').value || '未选择'}
获知渠道：${document.getElementById('RecruitmentForm-channel').value || '未选择'}
内推人姓名：${document.getElementById('RecruitmentForm-referrer').value || '无'}
招聘平台：${document.getElementById('RecruitmentForm-platform').value || '无'}\n`;

    // --- 2. 教育经历拼接（修复：过滤掉模板） ---
    //     let educationText = '--- 教育经历 ---';
    //     // 只选择不在模板内的输入框
    //     const schoolList = Array.from(document.querySelectorAll('input[name="contact[教育经历_学校][]"]'))
    //                             .filter(el => !el.closest('.education-item-template'));
        
    //     schoolList.forEach((item, index) => {
    //       const i = index; // 对应实际显示的索引
    //       const school = item.value || '未填写';
    //       const level = document.querySelectorAll('.education-container select[name="contact[教育经历_学历][]"]')[i]?.value || '未选择';
    //       const major = document.querySelectorAll('.education-container input[name="contact[教育经历_专业][]"]')[i]?.value || '未填写';
    //       const start = document.querySelectorAll('.education-container input[name="contact[教育经历_起始时间][]"]')[i]?.value || '未选择';
    //       const end = document.querySelectorAll('.education-container input[name="contact[教育经历_结束时间][]"]')[i]?.value || '未选择';
    //       const experience = document.querySelectorAll('.education-container textarea[name="contact[教育经历_在校经历][]"]')[i]?.value || '无';

    //       educationText += `
    // 教育经历 ${index + 1}：
    // 学校名称：${school}
    // 学历：${level}
    // 专业：${major}
    // 在校时间：${start} — ${end}
    // 在校经历：${experience}
    // `;
    //     });

    // --- 3. 工作经验拼接（修复：过滤掉模板） ---
    //     let experienceText = '\n--- 工作经验 ---';
    //     const isNoExp = document.getElementById('NoExperienceCheckbox').checked;

    //     if (isNoExp) {
    //       experienceText += '\n状态：该申请人勾选了“没有工作经验”。\n';
    //     } else {
    //       const companyList = Array.from(document.querySelectorAll('input[name="contact[工作_公司][]"]'))
    //                               .filter(el => !el.closest('.experience-item-template'));
          
    //       companyList.forEach((item, index) => {
    //         const i = index;
    //         const company = item.value || '未填写';
    //         const dept = document.querySelectorAll('.experience-container input[name="contact[工作_部门][]"]')[i]?.value || '未填写';
    //         const position = document.querySelectorAll('.experience-container input[name="contact[工作_职位][]"]')[i]?.value || '未填写';
    //         const start = document.querySelectorAll('.experience-container input[name="contact[工作_起始时间][]"]')[i]?.value || '未选择';
    //         const end = document.querySelectorAll('.experience-container input[name="contact[工作_结束时间][]"]')[i]?.value || '未选择';
    //         const desc = document.querySelectorAll('.experience-container textarea[name="contact[工作_描述][]"]')[i]?.value || '无';

    //         experienceText += `
    // 工作经验 ${index + 1}：
    // 公司名称：${company}
    // 部门：${dept}
    // 职位：${position}
    // 起止时间：${start} — ${end}
    // 工作描述：${desc}
    // `;
    //       });
    //     }

    // --- 4. 实习经历 ---
    // const internshipValue = document.getElementById('RecruitmentForm-internship').value || '未填写';
    // const internshipText = `\n--- 实习经历 ---\n内容：${internshipValue}\n`;

    // --- 6. 法律声明 ---
    // const privacyText = `\n--- 法律声明 ---\n已阅读并同意隐私政策与使用条款：是\n`;

    // --- 7. 合并所有数据并赋值给隐藏域 ---
    // const finalFullBody = formattedData + educationText + experienceText + internshipText + privacyText;
    // const finalFullBody = formattedData + internshipText + privacyText;
    const finalFullBody = formattedData;
    formattedBodyInput.value = finalFullBody;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending..."; 
    }

    // ====================== 测试专用：打印数据 ======================
    console.log("%c--- 准备提交的数据汇总 ---", "color: blue; font-weight: bold; font-size: 14px;");
    console.log(finalFullBody);
    
    // 只是想看数据不想真的跳转页面
    // alert("检查控制台查看拼接数据！");
    // e.preventDefault();
  });
});
